import { render, staticRenderFns } from "./RealtimeCallDetailsTable.vue?vue&type=template&id=7471d324&scoped=true"
import script from "./RealtimeCallDetailsTable.vue?vue&type=script&lang=js"
export * from "./RealtimeCallDetailsTable.vue?vue&type=script&lang=js"
import style0 from "./RealtimeCallDetailsTable.vue?vue&type=style&index=0&id=7471d324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7471d324",
  null
  
)

export default component.exports